module.exports = __webpack_public_path__ + "img/stats.a06584ce.svg";